import { usePublicFeatureFlags } from '@/shared/api/featureFlagsQueries'

/**
 * Whether the Lottery module itself is enabled for this tenant - distinct from
 * useTombolaEnabled (a sub-feature flag inside Lottery). A disabled/missing module
 * row means /lottery 404s server-side (CheckFeatureFlag middleware); nav must not
 * offer a link to it.
 */
export function useLotteryEnabled(): boolean {
  const flagsQuery = usePublicFeatureFlags()
  return flagsQuery.data?.find((row) => row.module_name === 'lottery')?.enabled === true
}
